import PropTypes from 'prop-types'

import LogoIcon, { useLogoOnLight } from '@icons/Logo'

import Box from '@mui/material/Box'

BrandMark.propTypes = {
  /** Stops the logo linking home, for the signed out pages that have nowhere to send you */
  disabled: PropTypes.bool,
}

/**
 * The logo as it sits in a bar.
 *
 * @param {object} props - The component props.
 * @returns {JSX.Element} The rendered mark.
 */
export default function BrandMark({ disabled = false }) {
  const onLight = useLogoOnLight()

  return (
    <Box sx={styles.brand(onLight)}>
      <LogoIcon isLink={!disabled} onLight={onLight} height={28} />
    </Box>
  )
}

const styles = {
  // A white label logo is drawn for the dark bar it was asked for, so it keeps a plate to
  // sit on. Ours has an ink colourway and needs nothing behind it.
  brand: (onLight) => ({
    display: 'flex',
    alignItems: 'center',
    ...(onLight
      ? {}
      : {
          height: 40,
          px: 2,
          borderRadius: 2.5,
          backgroundColor: 'primary.main',
        }),
  }),
}
